import { Badge } from '@/components/ui/Badge';

const statusMap: Record<string, { variant: 'success' | 'warning' | 'error' | 'info' | 'purple' | 'default'; label: string }> = {
  draft: { variant: 'default', label: 'Draft' },
  sent: { variant: 'info', label: 'Sent' },
  viewed: { variant: 'purple', label: 'Viewed' },
  partial: { variant: 'warning', label: 'Partial' },
  paid: { variant: 'success', label: 'Paid' },
  overdue: { variant: 'error', label: 'Overdue' },
  void: { variant: 'default', label: 'Void' },
};

interface Props {
  status: string;
}

export function InvoiceStatusBadge({ status }: Props) {
  const config = statusMap[status] || { variant: 'default' as const, label: status };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
